import Divider from 'material-ui/Divider/Divider';

export default Divider;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Divider/index.ts